import { useEffect } from "react"

import { trackSelectContent } from "~utils/event-tracking/event-tracking-helpers"
import type { EntityType } from "~utils/event-tracking/event-tracking-constants"

export function useTrackSelectContent({
    entityId,
    entityType,
}: {
    entityId: string
    entityType: EntityType
}) {
    useEffect(() => {
        trackSelectContent({
            entityId,
            entityType,
        })
    }, [entityId])
}
